const SERVICE_ENVS = {
    "development": "http://localhost:7603/media-manifest/embed",
    "staging": "https://origin.staging.bloomberg.com/media-manifest/embed",
    "production": "https://www.bloomberg.com/media-manifest/embed",
    // domain that allows production non-news videos to be accessed in regions that block news websites
    "blpprod": "https://www.blpprofessional.com/media-manifest/embed",
};

export function getServerUrl(serviceEnv?: string, overrideDevServerUrl?: string): string {
    if (serviceEnv === "development") {
        return overrideDevServerUrl || SERVICE_ENVS.development;
    }

    return SERVICE_ENVS[serviceEnv] || SERVICE_ENVS.production;
}

export function getEmbedIframeUrl(id: string, serviceEnv?: string, overrideDevServerUrl?: string): string {
    return `${ getServerUrl(serviceEnv, overrideDevServerUrl) }/iframe?id=${ id }`;
}
